module.exports = __webpack_public_path__ + "img/lineChart.843fa52f.png";